import React, { Component } from 'react';
import { Container, Card, Table, Row, Col, Dropdown, Image, Button, ButtonGroup, Badge } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faFile, faFileExcel, faMinus, faPlus, faSearch, faSort, faSpinner, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { GET, POST } from '../../api';
import { CerisePink, ChineseSilver, Cultured, Gray, Lotion, SilverSand, SunsetOrange, VividMalachite, White } from '../../helpers/brand_colors_helper';
import { updateShoppingCart } from '../../redux/slices/marketPlaceSlice';
import Pagination from '../_partials/Pagination';
import { getUrlParam, numberFormat, trimThisDown } from '../../helpers/general_helpers';
import { toast } from 'react-toastify';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
const portalURL = process.env.REACT_APP_PORTAL_URL;

/**
 * MarketPlace Component
 */
class NewMarketPlace extends Component {

    servicesTypes = [
        { value: 0, label: 'Service' },
        { value: 1, label: 'Inventory' },
        { value: 2, label: 'Resources' },
        { value: 3, label: 'Assets' },
        { value: 4, label: 'Library' },
        { value: 5, label: 'Books' },
    ];
    searchFieldRef = React.createRef()
    state = {
        ServiceOrBundle: 'Services',
        filterServiceType: [0, 1, 5],
        openCheckOut: false,
        saving: false,
        Addservicesheader: null,
        cdt: {
            fetching: false,
            search: '',
            rows: 12,
            offset: 0,
            order: 'services.services_id',
            dir: 'DESC',
            lastPage: 0,
            page: 0,
            totalRecords: 0,
            rowsOptions: [10, 25, 50, 'All'],
            columns: [
                {
                    id: 'services.services_id',
                    column: 'services_id',
                    name: 'Newly Added',
                    sortable: true
                },
                {
                    id: 'services.services_name',
                    column: 'services_name',
                    name: 'Name',
                    sortable: true
                },
                {
                    id: 'services.services_fee',
                    column: 'services_fee',
                    name: 'Fee',
                    sortable: true
                },
                {
                    id: 'services.services_desc',
                    column: 'services_desc',
                    name: 'Description',
                    sortable: true
                },
                {
                    id: 'services.services_type',
                    column: 'services_type',
                    name: 'Type',
                    sortable: true
                },
                {
                    id: 'services.barcode',
                    column: 'barcode',
                    name: 'Barcode',
                    sortable: true
                },
            ],
            data: [],
        },
    }

    componentDidMount() {
        const {
            search,
            rows: limit,
            order,
            dir
        } = this.state.cdt;
        this.fetch({ search: search, limit: limit, order: order, dir: dir, page: 0 })
        let getUrlParamData = getUrlParam()
        if (getUrlParamData.order_num) {
            this.editSalesOrder(getUrlParamData.order_num);
        }
    }

    editSalesOrder = async (order_num) => {
        if (this.editSalesOrderReq) {
            this.editSalesOrderReq.abort();
        }
        this.editSalesOrderReq = new AbortController();
        const res = await GET('market-place/edit-sales-order', {
            signal: this.editSalesOrderReq.signal,
            params: {
                order_num: order_num
            },
        });
        if (res) {
            let resData = res.data
            this.setState({ saving: false, openCheckOut: false, Addservicesheader: resData.addservicesheader })
            this.props.updateShoppingCart(resData.addservices)
        }
    }

    fetch = async ({ search, limit, order, dir, page }) => {
        let { ServiceOrBundle } = this.state
        this.setState({ cdt: { ...this.state.cdt, fetching: true, } });

        if (this.fetchReq) {
            this.fetchReq.abort();
        }
        this.fetchReq = new AbortController();
        let res = null
        if (ServiceOrBundle == 'Services') {
            let fData = new FormData()
            fData.append('filterServiceType', JSON.stringify(this.state.filterServiceType))
            res = await POST('market-place/get', fData, {
                signal: this.fetchReq.signal,
                params: {
                    search,
                    order,
                    dir,
                    limit,
                    offset: parseInt(page) * parseInt(limit)
                },
            });
        } else {
            let fData = new FormData()
            res = await POST('market-place/get-services-bundles', fData, {
                signal: this.fetchReq.signal,
                params: {
                    search,
                    order,
                    dir,
                    limit,
                    offset: parseInt(page) * parseInt(limit)
                },
            });
        }
        if (res) {
            this.setState({
                cdt: {
                    ...this.state.cdt,
                    fetching: false,
                    search,
                    rows: parseInt(limit),
                    offset: parseInt(page) * parseInt(limit),
                    order,
                    dir,
                    page,
                    totalRecords: parseInt(res.data.total_count_filtered),
                    lastPage: Math.ceil(parseInt(res.data.total_count_filtered) / parseInt(limit)),
                    data: res.data.data,
                }
            });
        }
    }

    updateShoppingCart = (action, v) => {
        let shoppingCart = [...this.props.shoppingCart]
        if (action == 'bundle') {
            v.services.map((vv) => {
                shoppingCart.push({ ...vv, qty: 1, addservices_id: 0 })
            })
            this.props.updateShoppingCart(shoppingCart)
        } else {
            let findShoppingCart = shoppingCart.findIndex((vv, ii) => vv.services_id == v.services_id)
            if (action == 'delete' && findShoppingCart !== 1) {
                // JUST DELETE
                shoppingCart.splice(findShoppingCart, 1)
                this.props.updateShoppingCart(shoppingCart)
            } else {
                if (findShoppingCart === -1 && action == 'add') {
                    shoppingCart.push({ ...v, qty: 1, addservices_id: 0 })
                } else {
                    let newQty = (action == 'add') ? shoppingCart[findShoppingCart].qty + 1 : shoppingCart[findShoppingCart].qty - 1
                    if (newQty <= 0) {
                        // DELETE WHILE UPDATING THE COUNT
                        shoppingCart.splice(findShoppingCart, 1)
                    } else {
                        // console.log('shoppingCart[findShoppingCart]', shoppingCart[findShoppingCart], newQty);
                        let newItem = { ...shoppingCart[findShoppingCart] }
                        newItem.qty = newQty
                        shoppingCart[findShoppingCart] = newItem
                    }
                }
                this.props.updateShoppingCart(shoppingCart)
            }
        }
    }

    saveSalesOrder = async () => {
        this.setState({ saving: true })
        let shoppingCart = [...this.props.shoppingCart]
        if (shoppingCart.length <= 0) {
            this.setState({ saving: false })
            toast.error(t('No item in the cart!'));
            return
        }

        if (this.saveSalesOrderReq) {
            this.saveSalesOrderReq.abort();
        }
        this.saveSalesOrderReq = new AbortController();
        let selectedChild = this.props.selectedChild
        let Addservicesheader = this.state.Addservicesheader
        let fData = new FormData()
        fData.append('shoppingCart', JSON.stringify(shoppingCart))
        fData.append('child_id', selectedChild.child_id)
        fData.append('class_id', selectedChild.class_id)
        fData.append('addservices_num', (Addservicesheader) ? Addservicesheader.addservices_num : '')
        fData.append('addservicesheader_id', (Addservicesheader) ? Addservicesheader.addservicesheader_id : '')
        const res = await POST('market-place/save-sales-order', fData, {
            signal: this.saveSalesOrderReq.signal,
            params: {

            },
        });
        if (res) {
            let resData = res.data
            if (resData.type) {
                shoppingCart = shoppingCart.map((v, i) => {
                    let findAddservice = resData.data.Addservices.find((vv) => vv.services_id == v.services_id)
                    if (findAddservice) {
                        return { ...v, addservices_id: findAddservice.addservices_id }
                    }
                })
                toast[resData.messageType](t(resData.message));
                this.setState({ saving: false, openCheckOut: true, Addservicesheader: resData.data.Addservicesheader })
                this.props.updateShoppingCart(shoppingCart)
            } else {
                this.setState({ saving: false })
                toast[resData.messageType](t(resData.message));
            }
        }
    }

    renderPaymentGateway = () => {
        let { cdt, filterServiceType, openCheckOut, saving, Addservicesheader } = this.state
        let { shoppingCart, authData, selectedChild } = this.props
        if (!Addservicesheader) {
            return null
        }
        let currencycode = authData.centerData.currencycode
        let gTotal = 0;
        let vatTotal = 0;
        let qtyTotal = 0;
        let center_id = authData.centerData.center_id
        let user_id = authData.loginData.user_id
        let child_id = selectedChild.child_id
        let child_name = selectedChild.child_name
        let payment_gateway_id = authData.centerData.payment_gateway_id
        var payment_gateway_url = new URL(authData.centerData.payment_gateway_url);
        shoppingCart.map((v, i) => {
            let services_fee = v.services_fee
            let services_vat = v.services_vat
            let qty = v.qty
            let services_vat_amount = services_fee * services_vat / 100
            let service_total = (services_fee + services_vat_amount)
            gTotal += service_total * qty
            vatTotal += services_vat_amount * qty
        })
        // TEMP MUST COME FROM DB
        payment_gateway_url.searchParams.append('paymentGateway', 'directpayment');

        payment_gateway_url.searchParams.append('parent_id', selectedChild.parent_id);
        payment_gateway_url.searchParams.append('parent_email', selectedChild.email1);
        payment_gateway_url.searchParams.append('parent_name', selectedChild.parent_name);
        payment_gateway_url.searchParams.append('parent_phone', selectedChild.phone1);
        payment_gateway_url.searchParams.append('renderPage', 'index-market-place');
        payment_gateway_url.searchParams.append('usingIframe', '1');
        payment_gateway_url.searchParams.append('actionFun', 'process-payment-market-place');
        payment_gateway_url.searchParams.append('addservicesheader_id', Addservicesheader?.addservicesheader_id);
        payment_gateway_url.searchParams.append('p', gTotal + ',' + center_id + ',' + user_id + ',' + child_id + ',' + payment_gateway_id + ',' + child_name + ',' + vatTotal);
        payment_gateway_url.searchParams.append('auth_key', authData.authKey);
        payment_gateway_url = payment_gateway_url.toString()
        // console.log('payment_gateway_url', payment_gateway_url);
        return <Button onClick={() => window.open(payment_gateway_url)}>Go to Payment page</Button>
        // return <iframe src={payment_gateway_url} title={''} style={{ height: '80vh', width: '100%' }}></iframe>
    }

    renderServices = (v, i) => {
        if (!v.services_id) {
            return null
        }
        let { openCheckOut } = this.state
        let { shoppingCart, authData, selectedChild } = this.props
        let currencycode = authData.centerData.currencycode
        let findShoppingCart = shoppingCart.find((vv) => vv.services_id == v.services_id)
        let this_servicesTypes = this.servicesTypes.find((vv) => vv.value == v.services_type)
        let services_fee = v.services_fee
        let services_vat = v.services_vat
        let services_vat_amount = services_fee * services_vat / 100
        let service_total = (services_fee + services_vat_amount)

        let serviceColor = 'primary'
        if (this_servicesTypes.value == 1) {
            serviceColor = 'success'
        }
        else if (this_servicesTypes.value == 5) {
            serviceColor = 'warning'
        }

        return <div key={i} style={{ width: '25%', }} className='py-2 px-2'>
            <div style={{ flex: 1, backgroundColor: White, borderRadius: 10 }} className='d-flex flex-column p-2'>
                <div className='position-relative mb-1'>
                    <Image src={(v.services_image)
                        ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/services/' + v.services_image
                        : require('../../assets/images/placeholder150.png')} style={{ width: '100%', height: 150, objectFit: 'cover', borderRadius: 10 }} />
                    {(!openCheckOut) &&
                        <Badge bg={serviceColor} className='position-absolute' style={{ top: 5, right: 5 }}>{this_servicesTypes.label}</Badge>
                    }
                </div>
                <div className='d-flex flex-column justify-content-between' style={{ flex: 1 }}>
                    <div className='mb-1'>
                        <div className='mb-1' style={{ fontWeight: 600, fontSize: 13 }}>{v.services_name}</div>
                        <div className='d-flex flex-row align-items-center mb-1'>
                            <div style={{ fontWeight: 600, fontSize: 13, color: CerisePink }} className='me-1'>{currencycode + ' ' + (service_total)}</div>
                            <div style={{ fontSize: 10, color: SilverSand, fontStyle: 'italic' }}>{'Includes VAT'}</div>
                        </div>
                    </div>
                    <div className='d-flex flex-column align-items-center justify-content-end'>
                        {(findShoppingCart)
                            ? <div className='d-flex flex-row align-items-center' style={{ width: '100%' }}>
                                <Button size='sm' onClick={() => this.updateShoppingCart('minus', v)}>
                                    <FontAwesomeIcon icon={faMinus} />
                                </Button>
                                <div className='px-3 d-flex flex-row justify-content-center align-items-center' style={{ fontWeight: 600, fontSize: 13, flex: 1 }}>
                                    <div className='d-flex flex-row justify-content-center align-items-center p-1' style={{ border: 'solid 1px ' + Cultured, width: '80%', backgroundColor: Lotion, borderRadius: 5 }}>
                                        {findShoppingCart.qty}
                                    </div>
                                </div>
                                <Button size='sm' onClick={() => this.updateShoppingCart('add', v)}>
                                    <FontAwesomeIcon icon={faPlus} />
                                </Button>
                            </div>
                            : <div className='d-flex flex-row align-items-center justify-content-around' style={{ width: '100%' }}>
                                <Button size='sm' style={{ width: '100%' }} onClick={() => this.updateShoppingCart('add', v)}>Add to Cart</Button>
                            </div>
                        }
                        <div className='d-flex flex-row align-items-center justify-content-around mt-1' style={{ width: '100%' }} >
                            <Button disabled={(v.services_attachment) ? false : true} size='sm' variant='outline-info' style={{ width: '100%' }} onClick={() => window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/services/' + v.services_attachment)}>More Details</Button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    }
    renderBundles = (v, i) => {
        let { openCheckOut, cdt } = this.state
        let { shoppingCart, authData, selectedChild } = this.props
        let currencycode = authData.centerData.currencycode

        let bundle_fee = 0
        let services_name = []
        v?.services && v?.services.map((v, i) => {
            services_name.push(v.services_name)
            let services_fee = v.services_fee
            let services_vat = v.services_vat
            let services_vat_amount = services_fee * services_vat / 100
            let service_total = (services_fee + services_vat_amount)
            bundle_fee += service_total
        })
        services_name = services_name.join(", ")

        return <div key={i} style={{ width: '25%', }} className='py-2 px-2'>
            <div style={{ flex: 1, backgroundColor: White, borderRadius: 10 }} className='d-flex flex-column p-2'>
                <div className='position-relative mb-1'>
                    <Image src={require('../../assets/images/placeholder150.png')} style={{ width: '100%', height: 150, objectFit: 'cover', borderRadius: 10 }} />
                </div>
                <div className='d-flex flex-column justify-content-between' style={{ flex: 1 }}>
                    <div className='mb-1'>
                        <div className='mb-1' style={{ fontWeight: 600, fontSize: 13 }}>{v.services_bundle}</div>
                        <div className='d-flex flex-row align-items-center mb-1'>
                            <div style={{ fontWeight: 600, fontSize: 13, color: CerisePink }} className='me-1'>{currencycode + ' ' + (bundle_fee.toFixed(2))}</div>
                            <div style={{ fontSize: 10, color: SilverSand, fontStyle: 'italic' }}>{'Includes VAT'}</div>
                        </div>
                    </div>
                    <div className='mb-1' style={{ fontSize: 12 }}>
                        <strong style={{ fontSize: 11, color: SilverSand, fontStyle: 'italic' }}>{'Included Services: '}</strong>
                        {(v.showAllServices) ? services_name : trimThisDown(services_name, 20)}
                        <strong className='cursor-pointer' onClick={() => {
                            cdt.data[i].showAllServices = (cdt.data[i].showAllServices) ? false : true
                            this.setState({ cdt })
                        }}>{(services_name.length > 20 && !v.showAllServices) ? 'See More' : ''}</strong>
                    </div>
                    <div className='d-flex flex-column align-items-center justify-content-end'>
                        <div className='d-flex flex-row align-items-center justify-content-around' style={{ width: '100%' }}>
                            <Button size='sm' style={{ width: '100%' }} onClick={() => this.updateShoppingCart('bundle', v)}>Add to Cart</Button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    }
    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        let { cdt, filterServiceType, openCheckOut, saving, ServiceOrBundle } = this.state
        let { shoppingCart, authData, selectedChild } = this.props
        let currencycode = authData.centerData.currencycode
        let gTotal = 0;
        let vatTotal = 0;
        let qtyTotal = 0;

        return (<div className='d-flex flex-row' style={{}}>
            <div style={{ width: 'calc(100vw - 254px)', overflow: 'hidden' }}>
                <div className='d-flex flex-row' style={{}}>
                    <div style={{ width: (openCheckOut) ? '0' : '70%', transitionDuration: '300ms', }}>
                        <div className='d-flex flex-column pe-3' style={{}}>
                            {/* FILTERS START */}
                            <div className='flex-column mb-3' style={{ display: (openCheckOut) ? 'none' : 'flex' }}>
                                <div className='d-flex flex-row align-items-center mb-2'>
                                    <div className='px-1' style={{ flex: 1 }}>
                                        <div className='cdt-search' style={{ height: 38, width: '100%', borderRadius: 20 }}>
                                            <input
                                                style={{
                                                    paddingLeft: 17
                                                }}
                                                type='text'
                                                ref={this.searchFieldRef}
                                                defaultValue={cdt.search}
                                                onChange={(e) =>
                                                    this.fetch({
                                                        search: e.target.value,
                                                        limit: cdt.rows,
                                                        order: cdt.order,
                                                        dir: cdt.dir,
                                                        page: 0,
                                                    })
                                                }
                                                placeholder={t('Search...')}
                                            />
                                            <button
                                                onClick={() => {
                                                    this.fetch({
                                                        search: '',
                                                        limit: cdt.rows,
                                                        order: cdt.order,
                                                        dir: cdt.dir,
                                                        page: 0,
                                                    });
                                                    this.searchFieldRef.current.value = '';
                                                }}>
                                                <FontAwesomeIcon
                                                    icon={cdt.search == '' ? faSearch : faXmark}
                                                    color={Gray}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div className='d-flex flex-row align-items-center px-1'>
                                        <div className='me-2' style={{ display: 'inline-block' }}>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light"
                                                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}>
                                                    {t('Show:') + ' ' + (cdt.rows == -1 ? 'All' : cdt.rows)}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    {cdt.rowsOptions.map((row, index) =>
                                                        <Dropdown.Item onClick={() => this.fetch({
                                                            search: cdt.search,
                                                            limit: row,
                                                            order: cdt.order,
                                                            dir: cdt.dir,
                                                            page: cdt.page,
                                                        })
                                                        }
                                                            key={index}>{row == -1 ? 'All' : row}</Dropdown.Item>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        <div className='me-2' style={{ display: 'inline-block' }}>
                                            <Dropdown>
                                                <Dropdown.Toggle variant='light'
                                                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }} className='crm-options-btn'>
                                                    <FontAwesomeIcon
                                                        icon={faSort}
                                                        style={{ fontSize: 13, marginRight: 5 }}
                                                    />{t('Sort')}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu style={{ width: 180 }}>
                                                    {cdt.columns
                                                        .filter(column => column.sortable)
                                                        .map((column, index) => {
                                                            return (
                                                                <Dropdown.Item key={index}
                                                                    onClick={() => this.fetch({
                                                                        search: cdt.search,
                                                                        limit: cdt.rows,
                                                                        order: column.id,
                                                                        dir: (cdt.order == column.id) ? cdt.dir == 'ASC' ? 'DESC' : 'ASC' : 'DESC',
                                                                        page: cdt.page,
                                                                    })}
                                                                    className='d-flex justify-content-between align-items-center'>
                                                                    {t(column.name)}
                                                                    {cdt.order == column.id &&
                                                                        <FontAwesomeIcon
                                                                            icon={cdt.dir == 'DESC' ? faArrowDown : faArrowUp}
                                                                            style={{ fontSize: 12 }}
                                                                        />}
                                                                </Dropdown.Item>
                                                            )
                                                        })}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex flex-row align-items-center'>
                                    <div className='me-3'>
                                        {/* BUNDLE OR SERVICE */}
                                        <ButtonGroup style={{ borderRadius: 20, overflow: 'hidden' }}>
                                            <Button variant={(ServiceOrBundle == 'Services') ? "success" : "light"} onClick={() => this.setState({ ServiceOrBundle: 'Services' }, () => {
                                                this.fetch({ search: cdt.search, limit: 10, order: cdt.order, dir: cdt.dir, page: 0 })
                                            })}>Services</Button>
                                            <Button variant={(ServiceOrBundle == 'Bundles') ? "success" : "light"} onClick={() => this.setState({ ServiceOrBundle: 'Bundles' }, () => {
                                                this.fetch({ search: cdt.search, limit: 10, order: cdt.order, dir: cdt.dir, page: 0 })
                                            })}>Bundles</Button>
                                        </ButtonGroup>
                                    </div>
                                    <div>
                                        {/* FILTER SERVICE */}
                                        {ServiceOrBundle == 'Services' &&
                                            <ButtonGroup style={{ borderRadius: 20, overflow: 'hidden' }}>
                                                <Button variant={(filterServiceType.includes(0) && filterServiceType.includes(1) && filterServiceType.includes(5)) ? "danger" : "light"} onClick={() => this.setState({ filterServiceType: [0, 1, 5] }, () => {
                                                    this.fetch({ search: cdt.search, limit: 10, order: cdt.order, dir: cdt.dir, page: 0 })
                                                })}>All</Button>
                                                <Button variant={(filterServiceType.includes(0) && !filterServiceType.includes(1) && !filterServiceType.includes(5)) ? "primary" : "light"} onClick={() => this.setState({ filterServiceType: [0] }, () => {
                                                    this.fetch({ search: cdt.search, limit: 10, order: cdt.order, dir: cdt.dir, page: 0 })
                                                })}>Services</Button>
                                                <Button variant={(filterServiceType.includes(1) && !filterServiceType.includes(0) && !filterServiceType.includes(5)) ? "success" : "light"} onClick={() => this.setState({ filterServiceType: [1] }, () => {
                                                    this.fetch({ search: cdt.search, limit: 10, order: cdt.order, dir: cdt.dir, page: 0 })
                                                })}>Inventory</Button>
                                                <Button variant={(filterServiceType.includes(5) && !filterServiceType.includes(0) && !filterServiceType.includes(1)) ? "warning" : "light"} onClick={() => this.setState({ filterServiceType: [5] }, () => {
                                                    this.fetch({ search: cdt.search, limit: 10, order: cdt.order, dir: cdt.dir, page: 0 })
                                                })}>Books</Button>
                                            </ButtonGroup>
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* FILTERS END */}
                            {/* ITEMS LISTING START */}
                            <div className='d-flex flex-row flex-wrap p-2 grey-section' style={{ borderRadius: 10, height: '66vh', overflowY: 'auto' }}>
                                {cdt.data.map((v, i) => {
                                    return (ServiceOrBundle == 'Services') ? this.renderServices(v, i) : this.renderBundles(v, i)
                                })}
                            </div>
                            {/* ITEMS LISTING END */}
                            <Pagination
                                pageCount={this.state.cdt.lastPage || 1}
                                forcePage={this.state.cdt.page}
                                callbackParams={{
                                    search: this.state.cdt.search,
                                    limit: this.state.cdt.rows,
                                    order: this.state.cdt.order,
                                    dir: this.state.cdt.dir,
                                }}
                                callback={this.fetch}
                            />
                        </div>
                    </div>
                    {/* SHopping CART START */}
                    <div style={{ width: '30%', height: '82vh', backgroundColor: White }}>
                        <div className='d-flex flex-column justify-content-between px-3'>
                            <div className='d-flex flex-column mb-1 py-1 px-2' style={{ fontSize: 20 }}>
                                <div className='d-flex flex-row flex-wrap justify-content-center align-items-center' style={{ flex: 1, fontWeight: 600 }}>Shopping Cart</div>
                            </div>
                            <div style={{ flex: 1 }}>
                                <div className='d-flex flex-column mb-1 pr-2' style={{ height: '61vh', overflowY: 'auto' }}>
                                    {shoppingCart.map((v, i) => {
                                        let this_servicesTypes = this.servicesTypes.find((vv) => vv.value == v.services_type)
                                        let services_fee = v.services_fee
                                        let services_vat = v.services_vat
                                        let qty = v.qty
                                        let services_vat_amount = services_fee * services_vat / 100
                                        let service_total = (services_fee + services_vat_amount)
                                        qtyTotal += v.qty
                                        gTotal += service_total * qty
                                        vatTotal += services_vat_amount * qty
                                        return <div key={i} className='d-flex flex-row my-1 position-relative' style={{}}>
                                            <Image src={(v.services_image)
                                                ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/services/' + v.services_image
                                                : require('../../assets/images/placeholder150.png')} style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 5 }} />
                                            <div className='d-flex flex-column' style={{ flex: 1 }}>
                                                <div className='ms-1 d-flex flex-row justify-content-between'>
                                                    <div className='ms-1 d-flex flex-row flex-wrap' style={{ fontWeight: 600, flex: 1 }}>{v.services_name}</div>
                                                    <Badge bg={(this_servicesTypes.value == 0) ? 'primary' : 'success'} className='mb-1'>{this_servicesTypes.label}</Badge>
                                                </div>
                                                <div className='d-flex flex-row align-items-center mb-1'>
                                                    <div style={{ fontWeight: 600, fontSize: 13, color: CerisePink }} className='me-1'>{currencycode + ' ' + (service_total)}</div>
                                                    <div style={{ fontSize: 10, color: SilverSand, fontStyle: 'italic' }}>{'Includes VAT'}</div>
                                                </div>
                                                <div className='d-flex flex-row px-2 align-items-center' style={{ flex: 1 }}>
                                                    {!openCheckOut &&
                                                        <Button size='sm' onClick={() => this.updateShoppingCart('minus', v)} disabled={openCheckOut}>
                                                            <FontAwesomeIcon icon={faMinus} />
                                                        </Button>
                                                    }
                                                    <div className='px-3 d-flex flex-row justify-content-center align-items-center' style={{ fontWeight: 600, fontSize: 13, flex: 1 }}>
                                                        <div className='d-flex flex-row justify-content-center align-items-center p-1' style={{ border: 'solid 1px ' + Cultured, width: '80%', backgroundColor: Lotion, borderRadius: 5 }}>
                                                            {v.qty}
                                                        </div>
                                                    </div>
                                                    {!openCheckOut &&
                                                        <Button size='sm' onClick={() => this.updateShoppingCart('add', v)} disabled={openCheckOut}>
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </Button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                            <div className='d-flex flex-column' style={{ fontSize: 16 }}>
                                <div className='d-flex flex-row justify-content-between mb-1 py-1' style={{}}>
                                    <div className='d-flex flex-row flex-wrap' style={{ flex: 1, color: SilverSand }}>{t('Total VAT')}</div>
                                    <div className='d-flex justify-content-end' style={{ flex: 1 }}>{currencycode + ' ' + numberFormat(vatTotal.toFixed(2))}</div>
                                </div>
                                <div className='d-flex flex-row justify-content-between mb-1 py-1' style={{}}>
                                    <div className='d-flex flex-row flex-wrap' style={{ flex: 1, color: SilverSand }}>{t('Grand Total')}</div>
                                    <div className='d-flex justify-content-end' style={{ flex: 1, color: CerisePink }}>{currencycode + ' '}{numberFormat(gTotal.toFixed(2))}</div>
                                </div>
                                <div className='d-flex flex-row mb-1 py-1' style={{}}>
                                    <Button variant='success' style={{ flex: 1 }} onClick={() => this.saveSalesOrder()} disabled={openCheckOut || saving}>
                                        <div className='d-flex flex-row align-items-center justify-content-center'>
                                            <div>{t('Proceed to Checkout')}</div>
                                            <div className='ms-2 d-flex flex-row justify-content-center align-items-center' style={{ backgroundColor: White, color: VividMalachite, borderRadius: 20, width: 20, height: 20 }}>{qtyTotal}</div>
                                            {saving &&
                                                <FontAwesomeIcon icon={faSpinner} className='ms-1 fa-spin' />
                                            }
                                        </div>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* SHopping CART START */}
                    {/* CHECKOUT START */}
                    <div style={{ width: (openCheckOut) ? '70%' : '0', transitionDuration: '300ms', height: '82vh', }}>
                        <div className='d-flex flex-column justify-content-between p-2 grey-section mx-2' style={{ borderRadius: 10, overflowY: 'hidden', height: '100%' }}>
                            <div className='d-flex flex-column justify-content-between align-items-center'>
                                {this.renderPaymentGateway()}
                            </div>

                            {/* <div >
                                <div className='d-flex flex-row'>
                                    <Button variant='outline-info' onClick={() => this.setState({ openCheckOut: false })} style={{ width: '30%' }} className='me-1'>Back to Cart</Button>
                                    <Button variant='success' onClick={() => this.setState({ openCheckOut: false })} style={{ width: '70%' }} className='ms-1'>
                                        <div className='d-flex flex-row align-items-center justify-content-center'>
                                            <div>{t('Pay')}{' ' + currencycode}</div>
                                            <div className='ms-2 d-flex flex-row justify-content-center align-items-center px-1' style={{ backgroundColor: White, color: VividMalachite, borderRadius: 20, height: 20 }}>{gTotal}</div>
                                        </div>
                                    </Button>
                                </div>
                            </div> */}

                        </div>
                    </div>
                    {/* CHECKOUT END */}
                </div>
            </div>

        </div>);
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    shoppingCart: state.marketPlace.shoppingCart,
    selectedChild: state.selectedChild.data,
    defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, { updateShoppingCart })(NewMarketPlace);
